<p-toast></p-toast>
<div class="system-documentation-form-content">
  <div class="system-documentation-layout-content">
    <div class="flex flex-row h-full flex-responsive gap-3 flex-wrap">

      <!-- Left Column - Document Names -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <div class="form-section">
          <div class="section-title">
            <h3>{{ 'Document Information' | translate }}</h3>
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Document Name (UZ)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['uz-Latn-UZ']"
              (change)="onNameChange()"
              placeholder="{{ 'Document Name' | translate }}"
            />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one document name is required' | translate }}</span>
            }
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Document Name (EN)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['en-US']"
              (change)="onNameChange()"
              placeholder="{{ 'Document Name' | translate }}"
            />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one document name is required' | translate }}</span>
            }
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Document Name (RU)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['ru-RU']"
              (change)="onNameChange()"
              placeholder="{{ 'Document Name' | translate }}"
            />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one document name is required' | translate }}</span>
            }
          </div>

          <div class="field-group">
            <label>{{ 'Documentation Block' | translate }}</label>
            <msf-select-paginated
              [(model)]="formData.blockId"
              [service]="systemDocumentationBlockService"
              serviceMethod="dictionariesSystemDocumentationBlockGetByQueryPost"
              [placeholder]="'Select block' | translate"
              optionLabel="names"
              optionValue="id"
              translateBy="names"
              searchBy="names"
            />
          </div>

          <div class="field-group mt-4" [class.has-error]="fieldErrors.visible">
            <div class="flex flex-column gap-3">
              <label class="checkbox-label">
                <app-checkbox
                  [(ngModel)]="formData.visible"
                  (change)="onVisibleChange()"
                  [label]="'Published' | translate">
                </app-checkbox>
              </label>
            </div>
          </div>

          <div class="field-group">
            <label>{{ 'Comment' | translate }}</label>
            <app-textarea
              [(ngModel)]="formData.comment"
              class="mt-2"
              style="width: 100%;"
              placeholder="{{ 'Enter comment' | translate }}"
            />
          </div>
        </div>
      </div>

      <!-- Divider - visible only on lg and md -->
      <p-divider layout="vertical" class="divider-vertical"></p-divider>

      <!-- Right Column - File Uploads by Language -->
      <div class="lg:col-6 md:col-6 sm:col-12">
        <div class="form-section files-section">
          <div class="section-title-compact">
            <h4>{{ 'Files by Language' | translate }}</h4>
          </div>

          <div class="file-upload-compact-wrapper">
            <div class="file-upload-item">
              <label class="file-label-compact">{{ 'File (UZ)' | translate }}</label>
              <app-document-file-upload
                #fileUploadUz
                [fileStorageId]="getFileStorageIdForLanguage('uz-Latn-UZ')"
                (fileSelected)="onFileSelected('uz-Latn-UZ', $event)"
                (fileRemoved)="onFileRemoved('uz-Latn-UZ')">
              </app-document-file-upload>
            </div>

            <div class="file-upload-item">
              <label class="file-label-compact">{{ 'File (EN)' | translate }}</label>
              <app-document-file-upload
                #fileUploadEn
                [fileStorageId]="getFileStorageIdForLanguage('en-US')"
                (fileSelected)="onFileSelected('en-US', $event)"
                (fileRemoved)="onFileRemoved('en-US')">
              </app-document-file-upload>
            </div>

            <div class="file-upload-item">
              <label class="file-label-compact">{{ 'File (RU)' | translate }}</label>
              <app-document-file-upload
                #fileUploadRu
                [fileStorageId]="getFileStorageIdForLanguage('ru-RU')"
                (fileSelected)="onFileSelected('ru-RU', $event)"
                (fileRemoved)="onFileRemoved('ru-RU')">
              </app-document-file-upload>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Form Actions - Bottom Right -->
  <div class="form-actions-footer">
    <app-secondary-button
      [title]="'Cancel' | translate"
      (action)="cancelForm()"
    >
    </app-secondary-button>

    <div  style="padding: 0;">
      <app-primary-button
        [loading]="isSaving()"
        (action)="saveSystemDocumentation()"
        title="Save"
      ></app-primary-button>
    </div>
  </div>
</div>

